import { useNavigate } from 'react-router-dom';

export default function useRedirect() {
  const nav = useNavigate();

  const redirect = (path: string) => {
    if (path) {
      if (path.startsWith('http')) {
        window.open(path, '_blank');
      } else {
        nav(path);
      }
    }
  };

  return redirect;
}
